





































import { Component, Prop, Vue } from "vue-property-decorator";
import { ConcisenessRepetition } from "../../../types/NewResults";
import { percentFromTotal } from "../../../utils";

// import AssetsMixin from "@/AssetsMixin";
// import Card from "../Card.vue";

@Component({
  components: {}
})
export default class Repetition extends Vue {
  
  @Prop() private repetition!: ConcisenessRepetition;
  @Prop() private totalSentences!: number;
  
  private percentFromTotal = percentFromTotal;
  private repetitionPercentage = 0

  private created() {
    console.log(this.repetition);
    this.repetitionPercentage = percentFromTotal(this.repetition.affectedSentences, this.totalSentences)
  }
}
